import { render } from "./ChartListPro.vue?vue&type=template&id=28198598&scoped=true"
import script from "./ChartListPro.vue?vue&type=script&lang=js"
export * from "./ChartListPro.vue?vue&type=script&lang=js"

import "./ChartListPro.vue?vue&type=style&index=0&id=28198598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28198598"]])

export default __exports__